;
var FormDocumentsSearch;
(function (FormDocumentsSearch) {
    __once('formDocumentsSearch', () => {
        const mainWrapperNode = document.querySelector('.view-display-id-documents_page');
        const filterAccordionNode = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('.search-form--filter-accordion');
        const filterAccordionTriggerNode = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('.search-form--filter-accordion--header');
        const formNode = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('form#views-exposed-form-documents-documents-page');
        const formHeaderNode = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('.form-documents--header');
        const formSortNode = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('select#edit-sort-bef-combine');
        const formSortDropdown = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('.form-documents--sort .dropdown');
        const formSortSelect = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('.form-select');
        const formDatepickerMinInput = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('.form-item-field-date-min input');
        const formDatepickerMaxInput = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('.form-item-field-date-max input');
        const formSubmitButton = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('#edit-submit-documents');
        const typeOfDocument = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('.form-item-field-type-of-document-all input');
        const typeOfDocumentCheckboxes = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelectorAll('#edit-field-type-of-document input');
        const typeOfFile = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('.form-item-file-type-all input');
        const typeOfFileCheckboxes = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelectorAll('#edit-file-type input');
        const categoryLabelNode = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('#edit-field-type-of-document--wrapper legend');
        const categoryFirstCheckbox = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('#edit-field-type-of-document-7');
        const fileTypeLabelNode = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('#edit-file-type--wrapper legend');
        const fileTypeFirstCheckbox = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('#edit-file-type-10');
        const ACCORDION_TOGGLE_CLASS = 'open';
        const DROPDOWN_TOGGLE_CLASS = 'open';
        const DATE_SEPARATOR = '-';
        const KEY_ENTER = 'Enter';
        function accordionToggleEvent(targetNode, toggleClass = ACCORDION_TOGGLE_CLASS) {
            targetNode.classList.toggle(toggleClass);
            if (targetNode.classList.contains(toggleClass)) {
                targetNode.setAttribute('aria-expanded', 'true');
            }
            else {
                targetNode.setAttribute('aria-expanded', 'false');
            }
        }
        function filterAccordion(trigger, target) {
            trigger.addEventListener('keydown', (event) => {
                if (event.key === KEY_ENTER) {
                    event.preventDefault();
                }
            });
            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                accordionToggleEvent(target);
                formHeaderNode === null || formHeaderNode === void 0 ? void 0 : formHeaderNode.classList.toggle(ACCORDION_TOGGLE_CLASS);
            });
            trigger.addEventListener('keyup', (event) => {
                if (event.key === KEY_ENTER) {
                    accordionToggleEvent(target);
                    formHeaderNode === null || formHeaderNode === void 0 ? void 0 : formHeaderNode.classList.toggle(ACCORDION_TOGGLE_CLASS);
                }
            });
        }
        function parseITDate(date, separator = '/') {
            return date ? {
                day: parseInt(date.split(separator)[0]),
                month: parseInt(date.split(separator)[1]),
                year: parseInt(date.split(separator)[2])
            } : {
                day: 0,
                month: 0,
                year: 0
            };
        }
        function extendedDateFormat(date, dateSeparator = '/') {
            let splitDate = [];
            if (Boolean(date)) {
                splitDate = date.split(dateSeparator);
                splitDate[0] = splitDate[0].length == 1 ? '0' + splitDate[0] : splitDate[0];
                splitDate[1] = splitDate[1].length == 1 ? '0' + splitDate[1] : splitDate[1];
                return splitDate.join(dateSeparator);
            }
            else {
                return '';
            }
        }
        function datepickerInit(inputNode) {
            const previousValue = inputNode.value;
            const previousDate = parseITDate(previousValue, DATE_SEPARATOR);
            const datepicker = new Datepicker(inputNode);
            datepicker.config({
                first_day_of_week: "Monday",
                first_date: new Date(2021, 0, 1),
                last_date: new Date(),
                format: d => {
                    return [
                        d.getDate(),
                        d.getMonth() + 1,
                        d.getFullYear(),
                    ].join(DATE_SEPARATOR);
                }
            });
            inputNode.setAttribute('autocomplete', 'off');
            if (!previousValue) {
                inputNode.value = '';
            }
            else {
                datepicker.setDate(new Date(previousDate.year, previousDate.month - 1, previousDate.day));
            }
        }
        function dropdownInit(target) {
            const selectedValueNode = target.querySelector('.selected');
            const dropdownOptions = target.querySelectorAll('.menu li');
            target.querySelector('.value').addEventListener('click', (e) => {
                target.classList.toggle(DROPDOWN_TOGGLE_CLASS);
            });
            target.addEventListener('keyup', (event) => {
                if (event.key === KEY_ENTER) {
                    target.classList.toggle(DROPDOWN_TOGGLE_CLASS);
                }
            });
            dropdownOptions.forEach(dropdownOption => {
                dropdownOption.addEventListener('keydown', (event) => {
                    if (event.key === KEY_ENTER) {
                        dropdownOption.click();
                    }
                });
                dropdownOption.addEventListener('click', (event) => {
                    selectedValueNode.innerHTML = dropdownOption.innerHTML.toLowerCase();
                    target.classList.remove(DROPDOWN_TOGGLE_CLASS);
                    formSortSelect.value = dropdownOption.dataset.sort;
                    formSubmitButton.click();
                });
            });
        }
        function overrideDateInput(inputNode, dateSeparator = '/') {
            inputNode.value = extendedDateFormat(inputNode.value, dateSeparator);
            inputNode.addEventListener('change', (e) => {
                inputNode.value = extendedDateFormat(inputNode.value, dateSeparator);
            });
        }
        function selectAllFilters() {
            let typeOfDocumentElements = typeOfDocumentCheckboxes.length;
            typeOfDocument === null || typeOfDocument === void 0 ? void 0 : typeOfDocument.addEventListener('change', (e) => {
                let value = typeOfDocument.checked;
                for (let i = 0; i < typeOfDocumentElements - 1; i++) {
                    typeOfDocumentCheckboxes[i].checked = value;
                }
            });
            for (let i = 0; i < typeOfDocumentElements - 1; i++) {
                typeOfDocumentCheckboxes[i].addEventListener('change', (e) => {
                    let value = typeOfDocumentCheckboxes[i].checked;
                    if (!value) {
                        typeOfDocumentCheckboxes[typeOfDocumentElements - 1].checked = value;
                    }
                });
            }
            let typeOfFileElements = typeOfFileCheckboxes.length;
            typeOfFile === null || typeOfFile === void 0 ? void 0 : typeOfFile.addEventListener('change', (e) => {
                let value = typeOfFile.checked;
                for (let i = 0; i < typeOfFileElements - 1; i++) {
                    typeOfFileCheckboxes[i].checked = value;
                }
            });
            for (let i = 0; i < typeOfFileElements - 1; i++) {
                typeOfFileCheckboxes[i].addEventListener('change', (e) => {
                    let value = typeOfFileCheckboxes[i].checked;
                    if (!value) {
                        typeOfFileCheckboxes[typeOfFileElements - 1].checked = value;
                    }
                });
            }
        }
        function generateCheckboxLabelID(sourceNode, targetNode) {
            if (sourceNode && targetNode) {
                targetNode.setAttribute('id', sourceNode.getAttribute('aria-describedby'));
            }
        }
        function init() {
            if (mainWrapperNode) {
                filterAccordion(filterAccordionTriggerNode, filterAccordionNode);
                datepickerInit(formDatepickerMinInput);
                datepickerInit(formDatepickerMaxInput);
                overrideDateInput(formDatepickerMinInput, DATE_SEPARATOR);
                overrideDateInput(formDatepickerMaxInput, DATE_SEPARATOR);
                dropdownInit(formSortDropdown);
                generateCheckboxLabelID(categoryFirstCheckbox, categoryLabelNode);
                generateCheckboxLabelID(fileTypeFirstCheckbox, fileTypeLabelNode);
                selectAllFilters();
            }
        }
        init();
    });
})(FormDocumentsSearch || (FormDocumentsSearch = {}));
